(function () {
  'use strict';

  function initFaq(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-lg-faq-item]'));

    function closeItem(item) {
      var button = item.querySelector('[data-lg-faq-question]');
      var outer = item.querySelector('[data-lg-faq-answer-outer]');
      item.setAttribute('data-open', 'false');
      button.setAttribute('aria-expanded', 'false');
      outer.style.height = '0px';
    }

    function openItem(item) {
      var button = item.querySelector('[data-lg-faq-question]');
      var outer = item.querySelector('[data-lg-faq-answer-outer]');
      var inner = item.querySelector('[data-lg-faq-answer-inner]');
      item.setAttribute('data-open', 'true');
      button.setAttribute('aria-expanded', 'true');
      outer.style.height = inner.offsetHeight + 'px';
    }

    items.forEach(function (item) {
      var button = item.querySelector('[data-lg-faq-question]');
      if (!button) return;

      button.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';

        items.forEach(function (other) {
          if (other !== item) closeItem(other);
        });

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });

    /* Recalculate the open panel's height on resize (text reflow) */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        items.forEach(function (item) {
          if (item.getAttribute('data-open') === 'true') openItem(item);
        });
      }, 150);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-lg-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor: re-init when this section reloads */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lg-faq]');
    if (root) initFaq(root);
  });
})();
